export class AppRoutes {
  // Public
  static LOGIN = '/login';
  static SELECT_COMPANY = '/selecionar-empresa';

  // Dashboard (ou rota principal protegida)
  static DASHBOARD = '/';

  // Administrador
  static ADMINISTRATOR = '/administrador';
  static ADMINISTRATOR_CREATE = '/administrador/cadastro';
  static ADMINISTRATOR_VIEW = '/administrador/visualizar/:uuid';

  static getAdministratorView(uuid: string) {
    return `/administrador/visualizar/${uuid}`;
  }

  // Cliente
  static CUSTOMER = '/cliente';
  static CUSTOMER_CREATE = '/cliente/cadastro';
  static CUSTOMER_VIEW = '/cliente/visualizar/:uuid';

  static getCustomerView(uuid: string) {
    return `/cliente/visualizar/${uuid}`;
  }

  // Separador
  static SEPARATOR = '/separador';
  static SEPARATOR_CREATE = '/separador/cadastro';
  static SEPARATOR_VIEW = '/separador/visualizar/:uuid';

  static getSeparatorView(uuid: string) {
    return `/separador/visualizar/${uuid}`;
  }

  // Locker
  static LOCKERS = '/lockers';
  static LOCKERS_CREATE = '/locker/cadastro';
  static LOCKERS_VIEW = '/locker/visualizar/:uuid';

  static getLockerView(uuid: string) {
    return `/locker/visualizar/${uuid}`;
  }

  // Organização
  static ORGANIZATION = '/organizacao';
  static ORGANIZATION_CREATE = '/organizacao/cadastro';
  static ORGANIZATION_VIEW = '/organizacao/visualizar/:uuid';

  static getOrganizationView(uuid: string) {
    return `/organizacao/visualizar/${uuid}`;
  }

  // Alocação
  static ALLOCATION = '/alocacao';
  static ALLOCATION_CREATE = '/alocacao/cadastro';
  static ALLOCATION_VIEW = '/alocacao/visualizar/:uuid';

  static getAllocationView(uuid: string) {
    return `/alocacao/visualizar/${uuid}`;
  }

  // Avisos
  static NOTICE = '/aviso';
  static NOTICE_CREATE = '/aviso/cadastro';
  static NOTICE_VIEW = '/aviso/visualizar/:uuid';

  static getNoticeView(uuid: string) {
    return `/aviso/visualizar/${uuid}`;
  }

  // Configurações
  static CONFIG = '/config';

  // Página não encontrada
  static NOT_FOUND = '*';
}
